angular.module('rjmNg.directives').directive "magentoConnectDatabase", [
  "$clientAppUrl"
  ($clientAppUrl) ->
    restrict: "E"
    templateUrl: "directive.magentoConnectDatabase.html"
    replace: false
    controllerAs: "view"
    scope:
      gotoNext: '&'
      prefUrl: '<'
      showSkip: '&'
    bindToController: true
    require: "^?rjmUi"
    controller: [
      "$routeParams"
      "InputConnections"
      "ConnectionMeta"
      "$timeout"
      "notification"
      "Clients"
      "Autodash"
      "jobService"
      "app"
      "jobTypes"
      "$anchorScroll"
      "$location"
      "appRoute"
      "emailNotificationService"
      "email"
      "timezoneService"
      "cloudbiConnectionUtils"
      "CLIENT_TYPE"
      (
        $routeParams
        InputConnections
        ConnectionMeta
        $timeout
        notification
        Clients
        Autodash
        jobService
        app
        jobTypes
        $anchorScroll
        $location
        appRoute
        emailNotificationService
        email
        timezoneService
        cloudbiConnectionUtils
        CLIENT_TYPE
      ) ->

        view = @

        
        _attempts = 1
        _clientId = $routeParams.clientId
        _connectionId = $routeParams.connectionId || null
        _nextStepUrl = appRoute("/magento/connect/googleAnalytics")

        view.whitelistIps = cloudbiConnectionUtils.AWS_IP_ADDRESS_STR

        view.encryptionOptions = [
          type: "ssh"
          text: "SSH Tunnel"
        ,
          type: "ciscovpn"
          text: "Cisco IPSec VPN"
        ,
          type: "mysqlssl"
          text: "MYSQL-SSL",
        ,
          type: "none"
          text: "None"
        ]

        view.isChannels = app.isMagentoChannels()
        view.connectionType = 'mysql'
        ConnectionMetaInstance = ConnectionMeta(_clientId)
        InputConnectionsInstance = InputConnections(_clientId)

        ## View URLs
        view.inviteMembersUrl = $clientAppUrl("/magento/invite")
        view.backtoPreferences = $clientAppUrl("/magento/preferences")
        view.dashboardUrl = $clientAppUrl("/")


        view.clientId = _clientId
        view.clientInfo = null
        view.allDoneMessage = "Your free trial is active and you can check out your new reporting dashboard. In 7 days when your trial comes to an end, we’ll contact you about payment. Enjoy!"
        Clients.get(view.clientId)
          .then (clientInfo) ->
            view.clientInfo = clientInfo
            {
              magento_store_table_prefix
              magento_store_db_name
            } = view.clientInfo.properties
            angular.extend view.clientInfo.properties,
              magento_store_table_prefix: magento_store_table_prefix or ""
              magento_store_db_name: magento_store_db_name or ""

            if(view.clientInfo.properties.magento_client_type is CLIENT_TYPE.EE)
              view.allDoneMessage = "Your account is all set up and you can now check out your new reporting dashboard. Enjoy!"

        timezoneService.fetch()
          .then (timezones) ->
            view.timezones = timezones.data

        view.connection =
          client_id: _clientId
          display_name: null
          name: null
          type: view.connectionType
          properties:
            host: null
            port: "3306"
            username: null
            status: "1"
            desiredTZ: null,
            sourceTZ: "UTC"
            noPhpPasswordEncryption: "1"
            encryption_sshHostAddress: null
            encryption_sshUsername: null
            encryption_sshPort: null
            useSSL: "false"
            encryption_gatewayAddress: null
            encryption_groupName: null
            encryption_groupSecret: null
            encryption_username: null
          credentials:
            password: null
            encryption_password: null

        view.selectedEncryption = "none"
        view.isPasswordFieldShown = true

        # View Booleans for ngIfs
        view.isTestingIntegration = false
        view.isLoading = false
        view.isUpdatingData = false
        view.isUpdateFinished = false
        view.isRunningUpdateCycle = false

        # Updating Data Status Messages
        view.updatingDataStatus = "Checking the structure of your data"
        view.updatingDataErrorMessage = false
        view.structSyncErrorMessage = false

        view.clickedToChangePassword = ->
          view.isPasswordFieldShown = true

        _connectIdRoute = (id) ->
          resultRoute = appRoute("/magento/database/mysql/#{id}")
          if(app.isMagentoChannels()) 
            resultRoute = appRoute("/magento/connect/mysql/#{id}") 
          return resultRoute

        _getConnectionFailError = (error) ->
          "#{error.failureExplanation.overview} Please contact support at <strong>support@rjmetrics.com</strong>"

        _handleQueueUpdateSuccess = ->
          ## 9. test full update completion
          view.updatingDataStatus = "Completing your data update"
          emailNotificationService.post(email.TYPE.FULL_UPDATE_COMPLETION)
          view.isRunningUpdateCycle = true
          $timeout ->
            _startJobStatusPoll jobTypes.FULL_UPDATE, ->
              view.isUpdatingData = false
              view.isUpdateFinished = true
            , null, 60000
          , 30000

        _handleQueueUpdateError = ->
          view.updatingDataErrorMessage = "We've encountered an error syncing your data. Please contact <a href='https://support.rjmetrics.com/hc/en-us/requests/new' target='_blank'>support</a>."

        _goToNextStep = () ->
          $location.path(_nextStepUrl)

        _queueAutodash = (metaId) ->
          view.updatingDataStatus = "Generating your reports"
          Autodash.queueMagentoAutodash(view.clientInfo, app.getUserId(), metaId)
            .then((response) ->
              ## 7. test autodash
              _startAutodashStatusPoll(view.clientId, response.id)
            , (error) ->
              view.updatingDataErrorMessage = "We've encountered an error while generating your reports. Please contact <a href='https://support.rjmetrics.com/hc/en-us/requests/new' target='_blank'>support</a>."
            )

        _startAutodashStatusPoll = (clientId, jobId)->
          Autodash.status(clientId, jobId)
          .then (result) ->
            if result.status is "success"
              # mark client as implemented
              if(app.isMagentoChannels())
                _goToNextStep()
              else
                _updateClientAndRunUpdate()
            else if result.status is "error"
              view.updatingDataErrorMessage = "We've encountered an error generating your reports. Our team is looking into it and will reach out shortly."
            else
              $timeout ->
                _startAutodashStatusPoll(clientId, jobId)
              , 5000
          .catch (error) ->
            view.updatingDataErrorMessage = "We've encountered an error generating your reports. Our team is looking into it and will reach out shortly."

        _startJobStatusPoll = (jobType, onSuccessCallback, jobCount = null, delay = 5000) ->
          jobService(jobType).fetch()
          .then (response) ->
            allJobs = response.data
            latestJobStatus = if allJobs.length then allJobs[0].status.name else null
            newJobRunning = allJobs.length is (jobCount + 1)
            if jobCount? and newJobRunning and latestJobStatus is "Completed Successfully"
              onSuccessCallback()
            else if jobCount? and newJobRunning and latestJobStatus.indexOf("Error") isnt -1
              view.structSyncErrorMessage = "We've encountered an error while checking the structure of your data. Please contact <a href='https://support.rjmetrics.com/hc/en-us/requests/new' target='_blank'>support</a>."
            else if not jobCount? and latestJobStatus == "Completed Successfully"
              onSuccessCallback()
            else
              $timeout ->
                _startJobStatusPoll jobType, onSuccessCallback, jobCount
              , delay

        _updateClientAndRunUpdate = () ->
          view.clientInfo.properties.is_implemented = true
          Clients.save view.clientInfo
          ## 8. queue full update
          jobService(jobTypes.FULL_UPDATE)
          .queue isForced : 1,
          _handleQueueUpdateSuccess,
          _handleQueueUpdateError

        _queueConnectionTest = (metaId) ->
          Clients.get(view.clientId)
          .then (clientInfo) ->
            view.clientInfo = clientInfo
            jobService(jobTypes.STRUCT_SYNC).fetch().then (response) ->
              structJobCount = response.data.length
              jobService(jobTypes.CONNECTION_TEST).queue(
                connectionId: metaId
                syncAndSample: 1
                magentoFastSSPackage: Autodash.getMagentoAutodashPackage(view.clientInfo)
                magentoPrefix: view.clientInfo.properties.magento_store_table_prefix
              ).then () ->
                _startConnectionStatusPoll metaId, structJobCount

        _startConnectionStatusPoll = (metaId, jobCount) ->
          ConnectionMetaInstance.status(metaId, true, false)
          .then((result) ->
            if result.status is "FAIL"
              view.isTestingIntegration = false
              view.isLoading = false
              notification.error(result.message, _getConnectionFailError(result), "magento-database", { dismissable: false, bindHtml: true })
            else if result.status is "OK"
              view.isTestingIntegration = false
              view.isLoading = false
              view.isUpdatingData = true
              ## 5. test struct sync
              _startJobStatusPoll(jobTypes.STRUCT_SYNC, () -> 
                _queueAutodash(metaId)
              , jobCount)
            else
              $timeout ->
                _startConnectionStatusPoll metaId, jobCount
              , 5000
          ,(error) ->
            notification.error("Error connecting database", _getConnectionFailError(error.status), "magento-database", { dismissable: false, bindHtml: true })
          )

        _createConnectionObject = ->
          view.connection.properties.encryption_type = view.selectedEncryption
          view.connection.properties.dbName = view.clientInfo.properties.magento_store_db_name
          view.connection.name = view.connection.display_name
          view.connection

        ## "Syncing Data" Process
        ## 1. Client database properties saved
        ## 2. connection saved
        ## 3. redirect to connection id specific page
        ## 4. connection tested
        ## 5. test struct sync
        ## 6. queue autodash
        ## 7. test autodash
        ## 8. queue full update
        ## 9. test full update completion
        view.saveIntegration = () ->
          notification.clear('magento-database')
          view.isTestingIntegration = true
          view.isLoading = true
          connectionObject = _createConnectionObject()
          ## 1. Client database properties saved
          Clients.save(view.clientInfo)
          .then (response) ->
            ## 2. connection saved
            InputConnectionsInstance.save(connectionObject)
            .then (response) ->
              ## 3. redirect to connection id specific page
              $location.path(_connectIdRoute(response.id))
              .search
                autosync: true
                attempt: _attempts
            .catch (error) ->
              view.isTestingIntegration = false
              view.isLoading = false
          .catch ({data}) ->
            $anchorScroll()
            view.isLoading = false
            view.isTestingIntegration = false
            notification.error("We've encountered an error saving your database details.", "Please verify that <strong>database name</strong> and <strong>table prefix</strong> are entered correctly.", "magento-database", { dismissable: false, bindHtml: true })

        

        $anchorScroll()

        view.$onInit = () ->
          if(app.isMagentoChannels() && view.prefUrl) then view.backtoPreferences = view.prefUrl

          if _connectionId
            view.isTestingIntegration = true
            view.isLoading = true
            InputConnectionsInstance.getById(_connectionId)
            .then (result) ->
              view.connection = result
              angular.extend view.connection.properties,
                sourceTZ: result.properties.sourceTZ or "UTC"
              view.isPasswordFieldShown = !!view.connection.credentials
              view.selectedEncryption = result.properties.encryption_type
              if $routeParams.attempt
                _attempts = $routeParams.attempt + 1
              if $routeParams.autosync
                ## 4. connection tested
                _queueConnectionTest result.meta_id
              else
                ConnectionMetaInstance.status(result.meta_id, true, true)
                  .then (success) ->
                    view.isLoading = false
                    view.isTestingIntegration = false
                    if success.status is "FAIL"
                      notification.error(success.message, _getConnectionFailError(success), "magento-database", { dismissable: false, bindHtml: true })
                    else if success.status is "OK"
                      view.isTestingIntegration = false
                      view.isLoading = false
                      view.isUpdatingData = true
                      ## test struct sync and 
                      _startJobStatusPoll(jobTypes.STRUCT_SYNC, _goToNextStep)
                    else
                      $timeout(() ->
                        _startConnectionStatusPoll(result.meta_id)
                      , 5000)

                  .catch (error) ->
                    view.isLoading = false
                    view.isTestingIntegration = false
            .catch (error) ->
              view.isLoading = false
              view.isTestingIntegration = false
          else
            InputConnectionsInstance.get()
            .then (response) ->
              mysqlConnections = response.filter (connection) ->
                connection.type is 'mysql'

              if (mysqlConnections.length)
                $location.path(_connectIdRoute(mysqlConnections[0].id))

        view

    ]
    link: (scope, element, attributes, rjmUi) ->

      scope.$watch "view.isLoading", () ->
        rjmUi?.blockUi "magentoConnectDatabase", scope.view.isLoading

]
